import {
  AccordionContent,
  AccordionHeader,
  AccordionItem,
  AccordionTrigger,
} from "ui/gluestack/accordion";
import { AssessmentPreview } from "../molecules/AssessmentPreview";
import { SubmittedFormModel } from "app/services/api/types/forms/models/SubmittedFormModel";
import { AssessmentHeader } from "../molecules/AssessmentHeader";
import { AssessmentActions } from "../molecules/AssessmentActions";
import { AssessmentAction } from "../types/AssessmentAction";
import { DefaultAssessmentEntryActions } from "../actions";

interface Props {
  form: SubmittedFormModel;
  footer?: React.ReactNode;
  actions?: AssessmentAction[];
  versioned?: boolean;
}

export function AssessmentAccordionPreview({
  form: submittedForm,
  footer,
  versioned,
  actions = DefaultAssessmentEntryActions,
}: Props) {
  return (
    <AccordionItem value={`${submittedForm.id}`}>
      <AccordionHeader>
        <AccordionTrigger className="focus:web:rounded-lg">
          {({ isExpanded }) => (
            <AssessmentHeader
              versioned={versioned}
              assessment={submittedForm}
              isExpanded={isExpanded}
            />
          )}
        </AccordionTrigger>
      </AccordionHeader>
      <AccordionContent>
        <AssessmentPreview submittedForm={submittedForm} />
        {footer || (
          <AssessmentActions assessment={submittedForm} actions={actions} />
        )}
      </AccordionContent>
    </AccordionItem>
  );
}
